var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Table',{attrs:{"loading":_vm.loading,"headers":_vm.headers,"items":_vm.userPayments},scopedSlots:_vm._u([{key:"item.transaction_timeWithTzUser",fn:function(ref){
var item = ref.item;
return [_vm._v(" "+_vm._s(("" + (_vm.datetimeFormatToAmericanFormat(item.transaction_timeWithTzUser))))+" ")]}},{key:"item.amount",fn:function(ref){
var item = ref.item;
return [_vm._v(" "+_vm._s(("" + (_vm.formatPrice(item.amount))))+" ")]}},{key:"item.payment_charge_amount",fn:function(ref){
var item = ref.item;
return [_vm._v(" "+_vm._s(("" + (_vm.formatPrice(item.payment_charge_amount))))+" ")]}},{key:"item.refund_amount",fn:function(ref){
var item = ref.item;
return [_vm._v(" "+_vm._s(("" + (_vm.formatPrice(item.refund_amount))))+" ")]}},{key:"item.discount_amount",fn:function(ref){
var item = ref.item;
return [_vm._v(" "+_vm._s(("" + (_vm.formatPrice(item.discount_amount))))+" ")]}},{key:"item.credit_amount",fn:function(ref){
var item = ref.item;
return [_vm._v(" "+_vm._s(("" + (_vm.formatPrice(item.credit_amount))))+" ")]}},{key:"item.credit_refund",fn:function(ref){
var item = ref.item;
return [_vm._v(" "+_vm._s(("" + (_vm.formatPrice(item.credit_refund))))+" ")]}}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }